var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container bg"},[_c('div',{staticClass:"login-box"},[_c('div',[_vm._v("请使用微信扫码登录")]),(_vm.url)?_c('img',{staticClass:"qrcode",attrs:{"src":_vm.url}}):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }